export enum SessionStatus {
  NOT_RUNNING = 'not_running',
  CREATING = 'creating',
  RUNNING = 'running',
  ERROR = 'error',
}
